<template>
  <div v-if="appointment && appointment.name" class="app-alert-error app-system-alert" id="payError"
       role="alert" ref="payError">
    <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <p ref="alertMessage" tabindex="-1" v-html="message"></p>
  </div>
</template>

<script setup>
import { computed, ref, onUpdated } from 'vue';
import MESSAGES from '@/assets/data/_systemFeedback';

// Props 
const props = defineProps({
  appointment: {
    type: Object,
    required: true,
  },
});

// Template Ref 
const alertMessage = ref(null);

// Computed Property 
const message = computed(() => {
  if (!props.appointment || !props.appointment.name) {
    return '';
  }
  
  const error = MESSAGES.find(fbk => fbk.errorType === 'modRes');
  let msg = error
      ? error.message
      : '{name} reservation must be modified at least 48 hours prior to the reservation time. ' +
      'Please cancel {confirmation} and make a new one.';

  // make feedback more specific
  const conf = props.appointment.confirmation
      ? `reservation <b>${props.appointment.confirmation}</b>`
      : 'this reservation';
  msg = msg.replace('{name}', props.appointment.name);
  msg = msg.replace('{confirmation}', conf);

  return msg;
});

// Lifecycle Hook 
onUpdated(() => {
  if (alertMessage.value) {
    alertMessage.value.focus();
  }
});
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/system-alert";
</style>
